const dates = [
    {
        date: "2020-03-12",
        month: "March",
        day: "12th",
        venue: "The Moon",
        location: "Telluride, CO",
        ticketURL: "https://www.eventbrite.com/e/the-futurebirds-with-flaural-tickets-91418283547"
    },
    {
        date: "2020-03-13",
        month: "March",
        day: "13th",
        venue: "The Moon",
        location: "Telluride, CO",
        ticketURL: "https://www.eventbrite.com/e/the-futurebirds-with-flaural-tickets-91418283547"
    },
    {
        date: "2020-03-14",
        month: "March",
        day: "14th",
        venue: "Mesa Theater",
        location: "Grand Junction, CO",
        ticketURL: "https://www.mesatheater.com/e/futurebirds-86178912447/"
    },
    {
        date: "2020-03-18",
        month: "March",
        day: "18th",
        venue: "The State Room",
        location: "Salt Lake City, UT",
        ticketURL: "https://www.eventbrite.com/e/futurebirds-tickets-90681391483"
    },
    {
        date: "2020-03-19",
        month: "March",
        day: "19th",
        venue: "The Olympic",
        location: "Boise, ID",
        ticketURL: "https://theolympicboise.com/2016/05/19/3-19-futurebirds/"
    },
    {
        date: "2020-03-20",
        month: "March",
        day: "20th",
        venue: "The Mint",
        location: "Hailey, ID",
        ticketURL: "https://www.eventbrite.com/e/futurebirds-tickets-90547543139"
    },
    {
        date: "2020-03-21",
        month: "March",
        day: "21st",
        venue: "Pink Garter Theater",
        location: "Jackson, WY",
        ticketURL: "https://www.pinkgartertheatre.com/e/futurebirds-triple-black-diamond-tour-90574098567/"
    },
    {
        date: "2020-03-26",
        month: "March",
        day: "26th",
        venue: "Bluebird Theater",
        location: "Denver, CO",
        ticketURL: "https://www.bluebirdtheater.net/events/detail/389631"
    }
];

export default dates;



// WEBPACK FOOTER //
// ./src/data/tour-dates.js